/**
 * Create a questions type's tree from flat array
 * @param {Array} questionList flat array of questions
 * @returns {Array} tree
 */
export const create = questionList => {
    const getTrees = (array, sortCallback = null) => {
        const getChildren = (array, parentId, sortCallback = null) => {
            const maxIdx = array.length - 1
            const children = []

            for (let i = maxIdx; i >= 0; i--) {
                if (array[i].relationships.parent.data.id === parentId) {
                    children.push(array.splice(i, 1)[0])
                }
            }

            if (sortCallback !== null) {
                children.sort(sortCallback)
            }

            return children.map(element => ({
                ...element,
                children: getChildren(array, element.id, sortCallback)
            }))
        }

        return getChildren([...array], null, sortCallback)
    }

    const sortByOrder = (a, b) => {
        const orderA = a.attributes?.order
        const orderB = b.attributes?.order
        if (orderA < orderB) return -1
        if (orderA > orderB) return 1
        return 0
    }

    return getTrees(questionList, sortByOrder)
}